import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInfexofi } from "../../Store/quiz/actions";

/**
 * Hook para manejar la configuración y datos del store
 */
export const useConfigData = () => {
  const dispatch = useDispatch();
  const [isLoadingConfig, setIsLoadingConfig] = useState(true);
  
  // Obtener datos desde Redux store
  const infexofi = useSelector((state: any) => state.quiz.infexofi);
  const store = useSelector((state: any) => {
    const { repLegal, ...filteredStore } = state.data;
    return filteredStore;
  });
  const assured: any = Object.values(store)[0];
  
  // Extraer datos del store o usar valores por defecto
  const afpData = (infexofi && infexofi.afpData) || [];
  const coverageData = (infexofi && infexofi.coverageData) || [];
  const serviceData = (infexofi && infexofi.serviceData) || [];
  const saludData = (infexofi && infexofi.saludData) || [];
  const genrerData = (infexofi && infexofi.genrerData) || [];
  const currencyData = (infexofi && infexofi.currencyData) || [];
  const modData = (infexofi && infexofi.modData) || [];
  const deferredYearsData = (infexofi && infexofi.deferredYearsData) || [];
  const tempYearsData = (infexofi && infexofi.tempYearsData) || [];
  const guaranteedYearsData = (infexofi && infexofi.guaranteedYearsData) || [];
  const relationshipData = (infexofi && infexofi.relationshipData) || [];
  const stepsFormData = (infexofi && infexofi.stepsFormData) || [];

  useEffect(() => {
    const fetchConfigData = async () => {
      try {
        setIsLoadingConfig(true);
        await getInfexofi(dispatch);
      } catch (error) {
        console.error("Error al obtener datos INFEXOFI:", error);
      } finally {
        setIsLoadingConfig(false);
      }
    };
    
    fetchConfigData();
  }, [dispatch]);

  return {
    isLoadingConfig,
    assured,
    afpData,
    coverageData,
    serviceData,
    saludData,
    genrerData,
    currencyData,
    modData,
    deferredYearsData,
    tempYearsData,
    guaranteedYearsData,
    relationshipData,
    stepsFormData,
  };
};
